import { computed, inject, Injectable, signal } from '@angular/core'
import { Router } from '@angular/router'
import { firstValueFrom } from 'rxjs'
import { SessionService } from 'superlikers-microsites-api'

import { User } from '@core/interfaces/users.interface'
import { UserService } from '@core/services/user/user.service'

@Injectable({
  providedIn: 'root'
})
export class UserStore {
  userService = inject(UserService)
  sessionService = inject(SessionService)
  router = inject(Router)

  #user = signal<User | null>(null)
  user = this.#user.asReadonly()

  isAuthenticated = computed(() => this.user()?.authenticated || false)

  availableAvatars = signal<string[]>([
    'https://superlikers-themes.s3.us-east-1.amazonaws.com/oxxo/perfil/personajes/Foto_default.png',
    'https://superlikers-themes.s3.us-east-1.amazonaws.com/oxxo/perfil/small_avatars/Hombre_1.png',
    'https://superlikers-themes.s3.us-east-1.amazonaws.com/oxxo/perfil/small_avatars/Hombre_2.png',
    'https://superlikers-themes.s3.us-east-1.amazonaws.com/oxxo/perfil/small_avatars/Hombre_3.png',
    'https://superlikers-themes.s3.us-east-1.amazonaws.com/oxxo/perfil/small_avatars/Hombre_4.png',
    'https://superlikers-themes.s3.us-east-1.amazonaws.com/oxxo/perfil/small_avatars/Hombre_5.png',
    'https://superlikers-themes.s3.us-east-1.amazonaws.com/oxxo/perfil/small_avatars/Hombre_6.png',
    'https://superlikers-themes.s3.us-east-1.amazonaws.com/oxxo/perfil/small_avatars/Mujer_1.png',
    'https://superlikers-themes.s3.us-east-1.amazonaws.com/oxxo/perfil/small_avatars/Mujer_2.png',
    'https://superlikers-themes.s3.us-east-1.amazonaws.com/oxxo/perfil/small_avatars/Mujer_3.png',
    'https://superlikers-themes.s3.us-east-1.amazonaws.com/oxxo/perfil/small_avatars/Mujer_4.png',
    'https://superlikers-themes.s3.us-east-1.amazonaws.com/oxxo/perfil/small_avatars/Mujer_5.png',
    'https://superlikers-themes.s3.us-east-1.amazonaws.com/oxxo/perfil/small_avatars/Mujer_6.png'
  ])

  async getUser() {
    const user = await this.userService.getUser()
    if (user?.authenticated) this.#user.set(user)
    return user
  }

  async updateUserData(data: Record<string, unknown>) {
    const currentUser = this.user()
    if (!currentUser) return

    const response = await this.userService.updateUser(data)
    if (response.success) {
      this.#user.set({ ...currentUser, ...data })
    }
  }

  async updateAvatar(avatar: string) {
    const currentUser = this.user()

    if (!currentUser) return

    const response = await this.userService.updateAvatar(avatar)

    if (response.success) {
      this.#user.set({ ...currentUser, avatar })
    }
  }

  async logout() {
    await firstValueFrom(this.sessionService.logout())
    this.#user.set(null)
    this.router.navigate(['/auth/login'])
  }
}
